import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const QnA008 = ({ isOpened, onChangeOpenedFlag }) => {
    const { t } = useTranslation();

    useEffect(() => {
        let content = document.getElementById("qna08");

        if (isOpened) {
            content.style.maxHeight = content.scrollHeight + "px";
        } else {
            content.style.maxHeight = null;
        }
    }, [isOpened]);

    return (
        <div className="accordion">
            <div className="accordion-title" onClick={() => onChangeOpenedFlag(7)}>
                <span className="hiclasstv-deepDarkgrey-text button">
                    <b>8. {t("FAQ_질문_8", { ns: "info" })}</b>
                </span>
            </div>
            <div className="accordion-content hiclasstv-darkgrey-text" id="qna08">
                <span className="d-flex" style={{ minWidth: 'max-content' }}>A.&nbsp;</span>
                <p>
                    {t("FAQ_질문_8_답변_1", { ns: "info" })}<br />
                    {t("FAQ_질문_8_답변_2", { ns: "info" })}<br />
                </p>
            </div>
        </div>
    );
}

export default QnA008;